import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Manuscript } from './pages/Manuscript';
import { legalDocs } from './data/legal';
import { useSmoothScroll } from './hooks/useSmoothScroll';
type AppProps = {
  heroHover?: 'trail' | 'ripple' | 'lens' | 'dissolve' | 'magnet';
};
export function App({
  heroHover = 'trail'
}: AppProps) {
  useSmoothScroll();
  return <BrowserRouter data-id="element-0" data-mp="31c9uy3vtszrg">
      <div className="w-full bg-mist-bg font-sans" data-id="element-1" data-mp="31ctd9lpe1q60">
        <Header data-id="element-2" data-mp="2wjqff1dkvuk0" />
        <main data-id="element-3" data-mp="2wj8f9tnsow6t">
          <Routes data-id="element-4" data-mp="2wip54z4dzc3c">
            <Route path="/" element={<Home heroHover={heroHover} data-id="element-6" data-mp="28u5vaf5our95" />} data-id="element-5" data-mp="2wi5lndz38fn7" />
            <Route path="/manuscript" element={<Manuscript data-id="element-8" data-mp="23vcjcr61v8b3" />} data-id="element-7" data-mp="28suveqfd63nb" />
            {legalDocs.map(d => <Route key={d.slug} path={`/${d.slug}`} element={<Legal doc={d} data-id="element-10" data-mp="3ik7jmqgv0tve" />} data-id="element-9" data-mp="23v2rey1g2r2r" />)}
            <Route path="*" element={<Navigate to="/" replace data-id="element-12" data-mp="3ii4ro0w5cqo1" />} data-id="element-11" data-mp="3ijftvw9y1qd1" />
          </Routes>
        </main>
        <Footer data-id="element-13" data-mp="3mjq1fdddwou0" />
        <CookieBanner data-id="element-14" data-mp="3mjgclt42snpw" />
      </div>
    </BrowserRouter>;
}